import { inject, Injectable } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { UpdateBlockListFormGroup } from "../interfaces/forms/update-block-list-form.interface";

@Injectable({
  providedIn: 'root',
})
export class UpdateBlockListFormService {
  fb = inject(FormBuilder);

  public form: UpdateBlockListFormGroup;

  public init(word: string = '') {
    this.form = this.fb.group({
      word: [word, [Validators.required]],
    });
  }
}
